<div class="modal-container tile-container">
    <div class="modal-header">
        <h2 class="modal-title" >New Medication</h2>
        <button class="close-btn" (click)="onClose()" type="button">
            &times;
        </button>
    </div>
    <div class="modal-body scrollbar-custom">
        <form
            [formGroup]="medicationForm"
            (ngSubmit)="onSubmit()"
            class="add-medication-form"
        >
            <!-- Row 1: Farm and Brand Name -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="farmName"
                        >Farm <span class="text-danger-required">*</span></label
                    >
                    <select
                        id="farmName"
                        formControlName="farmId"
                        class="form-control"
                    >
                        <option value="" disabled selected>Select Farm</option>
                        <option *ngFor="let farm of farms" [value]="farm.id">
                            {{ farm.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            medicationForm.get('farmId').invalid &&
                            medicationForm.get('farmId').touched
                        "
                        class="text-danger"
                    >
                        Please select a Farm.
                    </div>
                </div>

                <div class="form-group">
                    <label for="brand"
                        >Medication Brand Name<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="brand"
                        formControlName="name"
                        type="text"
                        class="form-control"
                        placeholder="Enter brand name"
                    />
                    <div
                        *ngIf="
                            medicationForm.get('name').invalid &&
                            medicationForm.get('name').touched
                        "
                        class="text-danger"
                    >
                        Please select brand name.
                    </div>
                </div>

                <div class="form-group">
                    <label for="arabicBrand">
                              Arabic Brand Name
                    </label>

                   <input
                        id="arabicBrand"
                        formControlName="arabicBrandName"
                        type="text"
                        class="form-control"
                        placeholder="Enter Arabic brand name"
                        dir="rtl"
                    />
                    <div
                        *ngIf="
                            medicationForm.get('arabicBrandName')?.invalid &&
                            medicationForm.get('arabicBrandName')?.touched
                        "
                        class="text-danger"
                    >
                        Only Arabic characters are allowed.
                    </div>
                </div>
            </div>

            <!-- Row 2: Min Stock and Medication Unit -->
            <div class="form-row mb-3">
                <div class="form-group">
                    <label for="minimumStockAlert"
                        >Min Stock<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="minimumStockAlert"
                        formControlName="minimumStockAlert"
                        type="number"
                        class="form-control"
                        placeholder="Enter minimum stock level to be notified"
                    />
                    <div
                        *ngIf="
                            medicationForm.get('minimumStockAlert').invalid &&
                            medicationForm.get('minimumStockAlert').touched
                        "
                        class="text-danger"
                    >
                        Please enter minimum stock level.
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="
                            medicationForm.get('minimumStockAlert').errors?.min
                        "
                    >
                        Value must be non-negative.
                    </div>
                </div>

                <div class="form-group">
                    <label for="medicationUnit"
                        >Medication Unit<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        id="medicationUnit"
                        formControlName="medicationUnit"
                        class="form-control"
                    >
                        <option value="" disabled selected>Select unit</option>
                        <option
                            *ngFor="let unit of medicationUnitOptions"
                            [ngValue]="unit.value"
                        >
                            {{ unit.label }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            medicationForm.get('medicationUnit').invalid &&
                            medicationForm.get('medicationUnit').touched
                        "
                        class="text-danger"
                    >
                        Please select medication unit.
                    </div>
                </div>
            </div>

            <!-- Row 3: Supplier | Classification | Chick Type -->
            <div class="form-row mb-3 three-cols">
                <div class="form-group">
                    <label for="supplier"
                        >Supplier<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        id="supplier"
                        formControlName="supplierId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Please choose supplier
                        </option>
                        <option
                            *ngFor="let supplier of suppliers"
                            [value]="supplier.id"
                        >
                            {{ supplier.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            medicationForm.get('supplierId').invalid &&
                            medicationForm.get('supplierId').touched
                        "
                        class="text-danger"
                    >
                        Please select supplier.
                    </div>
                </div>

                <div class="form-group">
                    <label for="classification"
                        >Classification<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        id="classification"
                        formControlName="classificationId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Select classification
                        </option>
                        <option
                            *ngFor="let classification of classifications"
                            [value]="classification.id"
                        >
                            {{ classification.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            medicationForm.get('classificationId').invalid &&
                            medicationForm.get('classificationId').touched
                        "
                        class="text-danger"
                    >
                        Please select classification.
                    </div>
                </div>

                <div class="form-group">
                    <label for="chickType"
                        >Chick Type<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        id="chickType"
                        formControlName="chickTypeId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Select chick type
                        </option>
                        <option
                            *ngFor="let chickType of chickTypes"
                            [value]="chickType.id"
                        >
                            {{ chickType.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            medicationForm.get('chickTypeId').invalid &&
                            medicationForm.get('chickTypeId').touched
                        "
                        class="text-danger"
                    >
                        Please select chick type.
                    </div>
                </div>
            </div>

            <!-- Row 4: Batch Number | Quantity | Expiry Date -->
            <div class="form-row mb-3 three-cols">
                <div class="form-group">
                    <label for="batchNumber"
                        >Batch Number<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="batchNumber"
                        formControlName="batchNumber"
                        type="text"
                        class="form-control"
                        placeholder="Enter batch number"
                    />
                    <div
                        *ngIf="
                            medicationForm.get('batchNumber').invalid &&
                            medicationForm.get('batchNumber').touched
                        "
                        class="text-danger"
                    >
                        Please enter batch number.
                    </div>
                </div>

                <div class="form-group">
                    <label for="quantity"
                        >Quantity (Boxes)<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="quantity"
                        formControlName="qty"
                        type="number"
                        class="form-control"
                        placeholder="Enter quantity"
                    />
                    <div
                        *ngIf="
                            medicationForm.get('qty').invalid &&
                            medicationForm.get('qty').touched
                        "
                        class="text-danger"
                    >
                        Please enter quantity.
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="medicationForm.get('qty').errors?.min"
                    >
                        Value must be non-negative.
                    </div>
                </div>

                <div class="form-group">
                    <label for="expireDate"
                        >Expiration Date<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="expireDate"
                        formControlName="expiryDate"
                        type="date"
                        class="form-control"
                        [attr.min]="currentDate"
                        (click)="triggerDatePicker($event)"
                    />
                    <div
                        *ngIf="
                            medicationForm.controls['expiryDate'].errors?.[
                                'futureDate'
                            ]
                        "
                        class="text-danger"
                    >
                        The date must be today or in the future.
                    </div>
                    <div
                        *ngIf="
                            medicationForm.get('expiryDate').invalid &&
                            medicationForm.get('expiryDate').touched
                        "
                        class="text-danger"
                    >
                        Please select expiry date.
                    </div>
                </div>
            </div>

            <!-- Row 5: Chick Age From | Chick Age To | Application Type -->
            <div class="form-row mb-3 three-cols">
                <div class="form-group">
                    <label for="chickAgeFrom"
                        >Chick Age From (days)<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="chickAgeFrom"
                        formControlName="chickAgeFrom"
                        type="number"
                        class="form-control"
                        placeholder="Enter age from"
                    />
                    <div
                        *ngIf="
                            medicationForm.get('chickAgeFrom').invalid &&
                            medicationForm.get('chickAgeFrom').touched
                        "
                        class="text-danger"
                    >
                        Please enter age from.
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="medicationForm.get('chickAgeFrom').errors?.min"
                    >
                        Value must be non-negative.
                    </div>
                </div>

                <div class="form-group">
                    <label for="chickAgeTo"
                        >Chick Age To (days)<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <input
                        id="chickAgeTo"
                        formControlName="chickAgeto"
                        type="number"
                        class="form-control"
                        placeholder="Enter age to"
                    />
                    <div
                        *ngIf="
                            medicationForm.get('chickAgeto').invalid &&
                            medicationForm.get('chickAgeto').touched
                        "
                        class="text-danger"
                    >
                        Please enter age to.
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="medicationForm.get('chickAgeto').errors?.min"
                    >
                        Value must be non-negative.
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="
                            medicationForm.get('chickAgeFrom').valid &&
                            medicationForm.get('chickAgeto').dirty &&
                            medicationForm.get('chickAgeFrom').value >
                                medicationForm.get('chickAgeto').value
                        "
                    >
                        Age to must be greater than age from.
                    </div>
                </div>

                <div class="form-group">
                    <label for="applicationType"
                        >Application Type<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <select
                        id="applicationType"
                        formControlName="applicationId"
                        class="form-control"
                    >
                        <option value="" disabled selected>
                            Select application
                        </option>
                        <option
                            *ngFor="let type of applications"
                            [value]="type.id"
                        >
                            {{ type.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            medicationForm.get('applicationId').invalid &&
                            medicationForm.get('applicationId').touched
                        "
                        class="text-danger"
                    >
                        Please select application type.
                    </div>
                </div>
            </div>

            <!-- Row 6: Note -->
            <div class="form-row mb-2">
                <div class="form-group">
                    <label for="description">Notes</label>
                    <textarea
                        id="description"
                        formControlName="description"
                        class="form-control"
                        placeholder="Additional Notes"
                    ></textarea>
                </div>
            </div>

            <!-- Submit Button -->
            <div class="form-actions">
                <button
                    class="btn close-btn-secondary"
                    type="button"
                    (click)="onClose()"
                >
                    Close
                </button>
                <button
                    class="btn submit-btn"
                    type="submit"
                    [disabled]="isLoading$ | async"
                >
                    <span class="submit-button-text" *ngIf="!isAuthLoading"
                        >Save Medication Record</span
                    >
                    <span class="submit-button-text" *ngIf="isAuthLoading"
                        >Submitting...</span
                    >
                </button>
                <img
                    *ngIf="isLoading$ | async"
                    src="assets/img/loader.gif"
                    alt="Loading..."
                    class="loader-image mt-2"
                />
            </div>
        </form>
    </div>
</div>
